import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectInsuranceRelatedDataFetching } from '../../../../../redux/manage-insurances/selectors/common';
import { manageInsurancesActions } from '../../../../../redux/manage-insurances/actions/manage-insurances-actions';

const useFetchToDoTaskInsurancesData = ({
  hasAdditionalPatientInsurances,
  todoTaskAssignmentId,
  userId,
  isCompleted,
}) => {
  const dispatch = useDispatch();

  const isInsuranceRelatedDataFetching = useSelector(
    selectInsuranceRelatedDataFetching,
  );

  useEffect(() => {
    dispatch(
      manageInsurancesActions.downloadToDoTaskInsurancesData({
        hasAdditionalPatientInsurances,
        todoTaskAssignmentId,
        userId,
        isCompleted,
      }),
    );
  }, [userId, todoTaskAssignmentId, hasAdditionalPatientInsurances]);

  useEffect(
    () => () => {
      dispatch(manageInsurancesActions.clearManageInsuranceRelatedData());
    },
    [],
  );

  return { isInsuranceRelatedDataFetching };
};

export default useFetchToDoTaskInsurancesData;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/hooks/useFetchToDoTaskInsurancesData.js